import React, { useState } from "react";
import { HashLink } from "react-router-hash-link";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../../contexts/AuthContext";
import toast from "react-hot-toast";

const SideBarMobile = ({ closeSidebar }) => {
  const { isLoggedIn, role, logout } = useAuth();
  const navigate = useNavigate();
  const [openMenu, setOpenMenu] = useState("");

  const handleToggle = (menu) => setOpenMenu(openMenu === menu ? "" : menu);
  const handleLogout = () => {
    logout();
    toast.success("Logged out successfully");
    navigate("/");
    closeSidebar?.();
  };

  const menuItems = [
    { label: "Home", to: "/" },
    { label: "About", to: "/about" },
    { label: "Contact Us", to: "/contact#contact" },
  ];

  const tnpscItems = [
    { label: "Group IV & VAO", to: "/#services" },
    { label: "Combined Engineering (CESE)", to: "/assistantEngineer" },
    { label: "Sub Inspector", to: "/subInspector" },
    { label: "Police Constable", to: "/policeConstable" },
  ];

  const trainingItems = [
    { label: "Summer computer course", to: "/computerCourse" },
    { label: "Communication training", to: "/communication" },
    { label: "Engineering counselling", to: "/counselling" },
    { label: "Placement training", to: "/placement" },
    { label: "Project training", to: "/project" },
  ];

  return (
    <div className="fixed inset-0 z-50 bg-black bg-opacity-50 flex justify-end">
      <div className="w-72 bg-white h-full p-5 flex flex-col justify-between">
        <div>
          <button className="text-red-600 text-2xl mb-5" onClick={closeSidebar}>
            ✕
          </button>

          {menuItems.map((item) => (
            <HashLink
              key={item.label}
              to={item.to}
              smooth
              onClick={closeSidebar}
              className="block text-lg py-3 border-b"
            >
              {item.label}
            </HashLink>
          ))}

          {isLoggedIn && (
            <HashLink
              to="/know-my-college"
              smooth
              onClick={closeSidebar}
              className="block text-lg py-3 border-b"
            >
              TNEA - Know My College
            </HashLink>
          )}

          <div className="mt-5">
            <button className="w-full text-left text-lg py-3 border-b" onClick={() => handleToggle("tnpsc")}>
              TNPSC {openMenu === "tnpsc" ? "−" : "+"}
            </button>
            {openMenu === "tnpsc" &&
              tnpscItems.map((item) => (
                <HashLink
                  key={item.label}
                  to={item.to}
                  smooth
                  onClick={closeSidebar}
                  className="block ml-4 py-2 text-sm text-gray-600"
                >
                  {item.label}
                </HashLink>
              ))}

            <button className="w-full text-left text-lg py-3 border-b" onClick={() => handleToggle("training")}>
              Training {openMenu === "training" ? "−" : "+"}
            </button>
            {openMenu === "training" &&
              trainingItems.map((item) => (
                <HashLink
                  key={item.label}
                  to={item.to}
                  smooth
                  onClick={closeSidebar}
                  className="block ml-4 py-2 text-sm text-gray-600"
                >
                  {item.label}
                </HashLink>
              ))}
          </div>

          {/* Role Based */}
          {isLoggedIn && role === "ADMIN" && (
            <HashLink to="/adminDashboard" smooth onClick={closeSidebar} className="block text-lg py-3 border-b">
              Admin Dashboard
            </HashLink>
          )}
          {isLoggedIn && role === "PUPIL" && (
            <HashLink to="/userDashboard" smooth onClick={closeSidebar} className="block text-lg py-3 border-b">
              User Dashboard
            </HashLink>
          )}
        </div>

        <div>
          {isLoggedIn ? (
            <button className="w-full py-3 bg-red-600 text-white rounded" onClick={handleLogout}>
              Logout
            </button>
          ) : (
            <HashLink to="/login" onClick={closeSidebar} className="block w-full text-center py-3 bg-blue-900 text-white rounded">
              Login
            </HashLink>
          )}
        </div>
      </div>
    </div>
  );
};

export default SideBarMobile;
